import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { TasksPage } from '@/features/tasks/components/tasks-page/tasks-page';
import { TASK_PRIORITIES } from '@/features/tasks/constants/task-priority.constants';
import { TASK_SOURCES } from '@/features/tasks/constants/task-source.constants';
import { TASK_STATUSES } from '@/features/tasks/constants/task-status.constants';

const QUICK_FILTERS = [
  'mis_tareas',
  'vencidas',
  'hoy',
  'esta_semana',
  'sin_asignar',
  'criticas',
  // Sprint Tareas Email-Reply — tareas con conversación linkeada cuyo
  // último mensaje del cliente sigue sin respuesta. Backend filtra por
  // tasks.response_status='pending_response' y ordena por createdAt asc
  // (más viejas primero — atacar la cola).
  'pendientes_respuesta',
  'portal',
] as const;

// `selectedTaskId` y `editTaskId` se separan deliberadamente (Fix 1 del
// audit tasks-admin): selectedTaskId abre el DETAIL drawer (read-only,
// permite ver source/createdBy/lifecycle), editTaskId abre el FORM
// drawer (mutación). Antes vivían colapsados en `selectedTaskId` y el
// drawer detalle nunca abría — siempre se ruteaba al form.
export const tasksSearchSchema = z.object({
  status: z.enum(TASK_STATUSES).optional(),
  priority: z.enum(TASK_PRIORITIES).optional(),
  assignedUserId: z.string().optional(),
  // Fix 3 del audit tasks-admin: filtro por source desde toolbar para que
  // el equipo aísle "tareas creadas por el bot_email" cuando empiece
  // volumen del Sprint Auth-for-Bots. Single-select (multi-select se
  // posterga hasta tener señal real de uso del equipo).
  source: z.enum(TASK_SOURCES).optional(),
  view: z.enum(['list', 'kanban', 'calendar']).optional(),
  q: z.string().optional(),
  selectedTaskId: z.string().uuid().optional(),
  editTaskId: z.string().uuid().optional(),
  page: z.coerce.number().int().min(1).optional(),
  quick: z.enum(QUICK_FILTERS).optional(),
  // Sprint Tasks Archive — true = tab Archivo (consume archived=true del
  // backend). Ausente o false = listado activo (default).
  archived: z.boolean().optional(),
  // Saved views multi-módulo — id de la vista guardada activa para
  // remarcar el tab correspondiente en SavedViewsBar.
  viewId: z.string().uuid().optional(),
});

export type TasksSearch = z.infer<typeof tasksSearchSchema>;

export const Route = createFileRoute('/_app/tasks/')({
  validateSearch: tasksSearchSchema,
  component: TasksPage,
});
